import { createResourceStore } from "@/lib/resource";

import type { Shop } from "./Shop";

import type { StockBatch } from "./StockBatch";
import type { Supplier } from "@/store/Supplier";

import type { FinanceTransaction } from "./FinanceTransaction";
import type { FinanceDebt } from "./FinanceDebt";

export interface SupplyReturn {
  id: string;
  product_id: string;
  shop_id: string;
  stock_batch_id: string;
  supplier_id?: string;
  quantity: number;
  reason: string;
  status: "pending" | "approved" | "completed" | "rejected";
  created_at?: string;
  updated_at?: string;
  amount: number;
  shop: Shop;
  stock_batch: StockBatch;
  supplier: Supplier;
  transactions: FinanceTransaction[];
  debts: FinanceDebt[];
}

export const useSupplyReturn = createResourceStore<SupplyReturn>(
  "supply-returns",
  () => ({
    stats: {
      filters: {
        start_date: null,
        end_date: null,
      },
      total_returns_count: 0,
      total_returned_qty: 0,
      total_returned_amount: 0,
      recovered_amount: 0,
      pending_recovery: 0,
      series: {
        labels: [],
        datasets: [],
      },
      top_returned_products: [],
      top_suppliers_impacted: [],
      reasons_distribution: [],
    },
  })
);
